import MascotLoadingOverlay from "./MascotLoadingOverlay";

const CardSkeleton = () => (
  <div className="animate-pulse bg-white border border-gray-200 rounded-xl p-4 space-y-3">
    <div className="flex items-center justify-between">
      <div className="h-4 w-32 bg-gray-200 rounded" />
      <div className="h-6 w-16 bg-gray-200 rounded-full" />
    </div>
    <div className="h-3 w-48 bg-gray-200 rounded" />
    <div className="flex gap-2">
      <div className="h-6 w-20 bg-gray-200 rounded-full" />
      <div className="h-6 w-20 bg-gray-200 rounded-full" />
    </div>
  </div>
);

/**
 * Liste/grid yükleme iskeleti.
 *
 * DİKKAT: Overlay'i bu bileşen kendisi render eder — çağıran tarafta AYRICA
 * `MascotLoadingOverlay` konulmamalı, yoksa iki metin üst üste biner.
 * Farklı bir metin için `message` prop'unu kullanın.
 *
 * @param {Array}  columns          Masaüstü tablo kolonları (variant="table")
 * @param {string} message          Overlay metni
 * @param {"table"|"cards"} variant Masaüstünde tablo mu kart grid'i mi
 */
export default function ListSkeleton({
  columns = [],
  rowCount = 20,
  mobileCardCount = 5,
  message,
  variant = "table",
}) {
  const cardCount = variant === "cards" ? Math.max(mobileCardCount, 8) : mobileCardCount;

  return (
    <div className="relative h-full min-h-[240px]">
      {/* Skeleton background */}
      <div className="h-full opacity-40 pointer-events-none">
        {variant === "cards" ? (
          /* Kart grid'i — kart tabanlı sayfalar (ör. onay bekleyen cihazlar) */
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {[...Array(cardCount)].map((_, i) => (
              <CardSkeleton key={i} />
            ))}
          </div>
        ) : (
          <>
            {/* Mobile skeleton */}
            <div className="md:hidden p-3 space-y-3 overflow-auto h-full">
              {[...Array(cardCount)].map((_, i) => (
                <CardSkeleton key={i} />
              ))}
            </div>

            {/* Desktop skeleton */}
            <div className="hidden md:block h-full overflow-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead
                  className="bg-gray-50 sticky top-0 z-30"
                  style={{ position: "sticky", top: 0, zIndex: 30 }}
                >
                  <tr>
                    {columns.map((col) => (
                      <th
                        key={col.label}
                        className={`px-4 py-3 text-left text-xs font-semibold text-gray-500 tracking-wider bg-gray-50 ${col.width || ""}`}
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 30,
                          backgroundColor: "#f9fafb",
                        }}
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {[...Array(rowCount)].map((_, i) => (
                    <tr key={i} className="animate-pulse">
                      {columns.map((col, ci) => (
                        <td key={ci} className="px-6 py-4">
                          <div className="space-y-2">
                            <div
                              className={`h-4 bg-gray-200 rounded ${col.skeletonWidth || "w-24"}`}
                            />
                            {col.skeletonExtra && (
                              <div className="h-3 w-16 bg-gray-200 rounded" />
                            )}
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <MascotLoadingOverlay message={message} />
    </div>
  );
}
